import React from 'react';
import { DocumentSummary } from '../../../types/chat';
import { Stack, Typography } from '@mui/material';

interface SummaryProps extends DocumentSummary {
	messagesOnPage: number;
	removedDuplicates?: number;
}

const PageSummary: React.FC<SummaryProps> = ({
	originalFileName,
	source,
	participantCount,
	participants,
	messagesInThread,
	messagesOnPage,
	removedDuplicates,
}) => {
	return (
		<Stack
			margin={'auto'}
			width={'80%'}
			padding={1}
			marginY={2}
			textAlign={'center'}
			borderRadius={2}
			sx={{ backgroundColor: 'background.paper', whiteSpace: 'pre-line' }}
			data-testid={`page-summary-container`}
		>
			<Typography fontWeight={'bold'}>Thread Summary Info</Typography>
			<Typography>{`Original File Name: ${originalFileName}`}</Typography>
			<Typography>{`Source Application: ${source}`}</Typography>
			{/* nb: original code has a bunch of refs here to Name/Start Time/Last Activity which aren't defined anywhere */}
			<Typography>{`Chat Type: ${participantCount <= 2 ? 'Direct Message' : 'Group'}`}</Typography>
			<Typography>{`${participantCount} Total Participants in Thread:`}</Typography>
			{participants.map((participant) => {
				{
					/* again, unused refs here for "Phone Owners Name in Thread" and "Group Admins" */
				}
				return (
					<Typography key={`participant-text-${participant}`} fontStyle={'italic'}>
						{participant}
					</Typography>
				);
			})}
			<Typography>{`Messages in thread: ${messagesInThread}`}</Typography>
			<Typography>{`Messages on page: ${messagesOnPage}`}</Typography>
			{Boolean(removedDuplicates) && <Typography>{`Duplicates removed: ${removedDuplicates}`}</Typography>}
		</Stack>
	);
};

export default PageSummary;
